
import { createSlice } from "@reduxjs/toolkit";
import { createFavouriteVendorItem, fetchFavouriteVendorsItems } from "./FavouriteVendorsThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const favouriteVendorsSlice = createSlice({
  name: "favouriteVendors",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchFavouriteVendorsItems.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFavouriteVendorsItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data || [];
      })
      .addCase(fetchFavouriteVendorsItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default favouriteVendorsSlice.reducer;